/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetUserMetricsSummaryPayload,
  GetUserMetricsSummaryPayload$Outbound,
  GetUserMetricsSummaryPayload$outboundSchema,
} from "../components/getusermetricssummarypayload.js";

export type GetUserMetricsSummarySecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetUserMetricsSummarySecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetUserMetricsSummarySecurity = {
  option1?: GetUserMetricsSummarySecurityOption1 | undefined;
  option2?: GetUserMetricsSummarySecurityOption2 | undefined;
};

export type GetUserMetricsSummaryRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getUserMetricsSummaryPayload: GetUserMetricsSummaryPayload;
};

/** @internal */
export type GetUserMetricsSummarySecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetUserMetricsSummarySecurityOption1$outboundSchema: z.ZodMiniType<
  GetUserMetricsSummarySecurityOption1$Outbound,
  GetUserMetricsSummarySecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getUserMetricsSummarySecurityOption1ToJSON(
  getUserMetricsSummarySecurityOption1: GetUserMetricsSummarySecurityOption1,
): string {
  return JSON.stringify(
    GetUserMetricsSummarySecurityOption1$outboundSchema.parse(
      getUserMetricsSummarySecurityOption1,
    ),
  );
}

/** @internal */
export type GetUserMetricsSummarySecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetUserMetricsSummarySecurityOption2$outboundSchema: z.ZodMiniType<
  GetUserMetricsSummarySecurityOption2$Outbound,
  GetUserMetricsSummarySecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getUserMetricsSummarySecurityOption2ToJSON(
  getUserMetricsSummarySecurityOption2: GetUserMetricsSummarySecurityOption2,
): string {
  return JSON.stringify(
    GetUserMetricsSummarySecurityOption2$outboundSchema.parse(
      getUserMetricsSummarySecurityOption2,
    ),
  );
}

/** @internal */
export type GetUserMetricsSummarySecurity$Outbound = {
  Option1?: GetUserMetricsSummarySecurityOption1$Outbound | undefined;
  Option2?: GetUserMetricsSummarySecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetUserMetricsSummarySecurity$outboundSchema: z.ZodMiniType<
  GetUserMetricsSummarySecurity$Outbound,
  GetUserMetricsSummarySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetUserMetricsSummarySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetUserMetricsSummarySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getUserMetricsSummarySecurityToJSON(
  getUserMetricsSummarySecurity: GetUserMetricsSummarySecurity,
): string {
  return JSON.stringify(
    GetUserMetricsSummarySecurity$outboundSchema.parse(
      getUserMetricsSummarySecurity,
    ),
  );
}

/** @internal */
export type GetUserMetricsSummaryRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetUserMetricsSummaryPayload: GetUserMetricsSummaryPayload$Outbound;
};

/** @internal */
export const GetUserMetricsSummaryRequest$outboundSchema: z.ZodMiniType<
  GetUserMetricsSummaryRequest$Outbound,
  GetUserMetricsSummaryRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getUserMetricsSummaryPayload: GetUserMetricsSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getUserMetricsSummaryPayload: "GetUserMetricsSummaryPayload",
    });
  }),
);

export function getUserMetricsSummaryRequestToJSON(
  getUserMetricsSummaryRequest: GetUserMetricsSummaryRequest,
): string {
  return JSON.stringify(
    GetUserMetricsSummaryRequest$outboundSchema.parse(
      getUserMetricsSummaryRequest,
    ),
  );
}
